class ViewToggle extends HTMLElement {
  connectedCallback() {
    if (this.dataset.ready === 'true') return;
    this.dataset.ready = 'true';

    const saved = localStorage.getItem('collection-view-preference') || this.dataset.defaultView || 'grid';
    this.applyView(saved);

    this.querySelectorAll('[data-view]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const view = btn.dataset.view;
        this.applyView(view);
        localStorage.setItem('collection-view-preference', view);
      });
    });
  }

  applyView(view) {
    const grid = document.querySelector('.product-grid');
    if (!grid) return;

    grid.classList.toggle('is-grid-view', view === 'grid');
    grid.classList.toggle('is-list-view', view === 'list');

    this.querySelectorAll('[data-view]').forEach((btn) => {
      const active = btn.dataset.view === view;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }
}

if (!customElements.get('view-toggle')) {
  customElements.define('view-toggle', ViewToggle);
}
